export default "__VITE_ASSET__BVXfjAwt__"